import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from '@mui/material';
import { CompareArrows as CompareArrowsIcon } from '@mui/icons-material';
import axios from 'axios';
import Keyvault from './Keyvault';
import config from "../../env.json"
import SearchIcon from '@mui/icons-material/Search';
import { useSearch } from './SearchContext';

interface Vault {
  ClientRsKeyVault_Nm: string;
  Id: string;
  name: string;
  type: string;
}

const VaultCloneTool: React.FC = () => {
  const [sourceVault, setSourceVault] = useState<string>('');
  const [targetVault, setTargetVault] = useState<string>('');
  const [sourceVaultId, setSourceIdVault] = useState('');
  const [targetVaultId, setTargetIdVault] = useState('');
  const [vaults, setVaults] = useState<Vault[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [cloning, setCloning] = useState<boolean>(false);
  const [statusMessage, setStatusMessage] = useState<string>('');

  const { searchText, setSearchText } = useSearch();

  useEffect(() => {
    const fetchVaults = async () => {
      setLoading(true);
      try {
        // TODO: Replace with actual API call
        setTimeout(async () => {

          const response = await axios.get(
            config.REACT_APP_ENV_API_BASE + '/KeyvaultControl/getVaultListAdmin',
            {
              headers: {
                'Content-Type': 'application/json',
                // Add other headers here if needed, e.g. Authorization
                'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
              },
            }
          );
          console.log("line 47", response?.data?.data);
          setVaults(response.data.data);
          setLoading(false);
        }, 500);
      } catch (err) {
        console.error('Error fetching vaults', err);
        setLoading(false);
      }
    };

    fetchVaults();
  }, []);

  const handleSourceVaultChange = (event: SelectChangeEvent) => {
    setSourceIdVault(vaults.find(v => v.ClientRsKeyVault_Nm === event.target.value)?.Id || '')
    setSourceVault(event.target.value);
    setStatusMessage('');
  };

  const handleTargetVaultChange = (event: SelectChangeEvent) => {
    setTargetIdVault(vaults.find(v => v.ClientRsKeyVault_Nm === event.target.value)?.Id || '')
    setTargetVault(event.target.value);
    setStatusMessage('');
  };

  const handleClone = async () => {
    if (!sourceVault || !targetVault) return;

    console.log(`Cloning from ${sourceVault} to ${targetVault}`)
    console.log(`Cloning from ${sourceVaultId} to ${targetVaultId}`)
    setCloning(true);
    setStatusMessage('');

    try {
      // TODO: Replace with actual clone API call
      const response = await axios.post(
        config.REACT_APP_ENV_API_BASE + `/KeyvaultControl/KeyvaultCopyAdmin?firstVaultNm=${sourceVault}&SecondVaultNm=${targetVault}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('login')}`
          }
        }
      );
      setStatusMessage(`Secrets successfully cloned from ${sourceVault} to ${targetVault}`);
      setCloning(false);

    } catch (err) {
      setStatusMessage('Failed to clone secrets.');
      setCloning(false);
    }
  };

  return (
    <Box bgcolor="#f5f5f5" sx={{
      overflowY: 'auto',
      pr: 2,
    }}>
      <Keyvault />
      <div className='search-container' style={{textAlign : "end", position : "relative", top :"-70px"}}>
          <TextField
            variant="outlined"
            placeholder="Search.."
            size="small"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              style: {
                background: 'white',
                borderRadius: 8,
                minWidth: 300,
                width: '100%',
                maxWidth: 500,
              },
            }}
          />
        </div>
      <Typography variant="h4" gutterBottom sx={{ mb: 4, position: "relative", left: "80px" }}>
        Vault Clone Tool
      </Typography>

      <Card sx={{ mb: 4, position: "relative", left: "80px", width: "90%" }}>
        <CardContent>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={5}>
              <FormControl fullWidth sx={{
                '& label.Mui-focused': {
                  color: '#734bd1',
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#ccc',
                    borderRadius: '5px',
                  },
                  '&:hover fieldset': {
                    borderColor: '#734bd1',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#734bd1',
                  },
                },
              }}>
                <InputLabel id="source-vault-label">Source Vault</InputLabel>
                <Select
                  labelId="source-vault-label"
                  value={sourceVault}
                  onChange={handleSourceVaultChange}
                  label="Source Vault"
                  disabled={loading}
                >
                  <MenuItem value="">
                    <em>Select source vault</em>
                  </MenuItem>
                  {vaults.map((vault) => (
                    <MenuItem
                      key={`source-${vault.Id}`}
                      value={vault.ClientRsKeyVault_Nm}
                    >
                      {vault.ClientRsKeyVault_Nm}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={2} textAlign="center">
              <CompareArrowsIcon fontSize="large" color="action" />
            </Grid>

            <Grid item xs={12} md={5}>
              <FormControl fullWidth sx={{
                '& label.Mui-focused': {
                  color: '#734bd1',
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#ccc',
                    borderRadius: '5px',
                  },
                  '&:hover fieldset': {
                    borderColor: '#734bd1',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#734bd1',
                  },
                },
              }}>
                <InputLabel id="target-vault-label">Target Vault</InputLabel>
                <Select
                  labelId="target-vault-label"
                  value={targetVault}
                  onChange={handleTargetVaultChange}
                  label="Target Vault"
                  disabled={loading}
                >
                  <MenuItem value="">
                    <em>Select target vault</em>
                  </MenuItem>
                  {vaults
                    .filter((vault) => vault.ClientRsKeyVault_Nm !== sourceVault)
                    .map((vault) => (
                      <MenuItem key={`target-${vault.Id}`} value={vault.ClientRsKeyVault_Nm} id={vault.Id}>
                        {vault.ClientRsKeyVault_Nm}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} textAlign="center">
              <Button
                  sx={{
                  backgroundColor : "#734bd1"
                }}
                variant="contained"
                onClick={handleClone}
                disabled={!sourceVault || !targetVault || cloning}
                startIcon={cloning ? <CircularProgress size={20} /> : <CompareArrowsIcon />}
              >
                {cloning ? 'Cloning...' : 'Clone Secrets'}
              </Button>
            </Grid>

            {statusMessage && (
              <Grid item xs={12} textAlign="center">
                <Typography variant="subtitle1" color="textSecondary">
                  {statusMessage}
                </Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default VaultCloneTool;
